import React, { useState } from 'react';
import { useAirlines, useInvalidate } from '../hooks/useApi';
import api from '../services/api';
import toast from 'react-hot-toast';
import { PlusIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';

export default function Airlines() {
  const { data: airlines, isLoading } = useAirlines();
  const { invalidateAll } = useInvalidate();
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', code: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) {
        await api.put(`/airlines/${editing.id}`, form);
        toast.success('U përditësua!');
      } else {
        await api.post('/airlines', form);
        toast.success('U shtua!');
      }
      setShowModal(false);
      setEditing(null);
      setForm({ name: '', code: '' });
      invalidateAll();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Gabim');
    }
  };

  const handleEdit = (item) => {
    setEditing(item);
    setForm({ name: item.name, code: item.code || '' });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Jeni i sigurt?')) return;
    try {
      await api.delete(`/airlines/${id}`);
      toast.success('U fshi!');
      invalidateAll();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Gabim');
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <h1 className="text-2xl font-bold text-gray-900">Kompanite Ajrore</h1>
        <button onClick={() => { setEditing(null); setForm({ name: '', code: '' }); setShowModal(true); }} className="btn-primary flex items-center gap-2">
          <PlusIcon className="w-5 h-5" /> Shto Kompani
        </button>
      </div>

      <div className="card">
        {isLoading ? (
          <div className="flex justify-center py-8"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div></div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {airlines?.map((item) => (
              <div key={item.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <p className="font-medium">{item.name}</p>
                  {item.code && <p className="text-sm text-gray-500">{item.code}</p>}
                </div>
                <div className="flex gap-1">
                  <button onClick={() => handleEdit(item)} className="p-1 text-gray-500 hover:text-primary-600"><PencilIcon className="w-5 h-5" /></button>
                  <button onClick={() => handleDelete(item.id)} className="p-1 text-gray-500 hover:text-red-600"><TrashIcon className="w-5 h-5" /></button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6">
            <h2 className="text-xl font-bold mb-4">{editing ? 'Ndrysho' : 'Shto'} Kompani</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div><label className="block text-sm font-medium text-gray-700 mb-1">Emri *</label><input type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="input-field" required /></div>
              <div><label className="block text-sm font-medium text-gray-700 mb-1">Kodi</label><input type="text" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} className="input-field" maxLength="10" /></div>
              <div className="flex gap-3 pt-4">
                <button type="button" onClick={() => setShowModal(false)} className="btn-secondary flex-1">Anulo</button>
                <button type="submit" className="btn-primary flex-1">Ruaj</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
